// routes/index.js
import { Route, Navigate } from "react-router-dom";
//import Dashboard from "../features/dashboard";




import UserList from "../features/usermanagement";
import Reports from "../pages/reports";



import Masters from "../pages/Master";
import WinderMachine from "../pages/Master/windermachine";
import Party from "../features/master/PartyMaster";
import Product from "../pages/Master/product";
import ProductIndex from "../pages/Master/product";
import TransactionIndex from "../features/decklematching/TransactionIndex";
import SalesIndex from "../pages/OrderManagementDashboard";
import ProductionManagement from "../pages/ProductionDashboard";
import ViewMasterAdmin from "../pages/masteradmin";
import RoleManagement from "../features/usermanagement/RoleManagement";
import CostingManagement from "../pages/CostingDashboard";
import BillOfMaterialIndex from "../pages/BillOfMaterialDashboard";

import ViewAllRequests from "../Layout/View-All-Rquests";
import ApiErrorPage from "../Layout/ApiErrorPage";


import OrgOverview from "../features/dashboard/organisation-overview";

import PurchaseManagement from "../pages/PurchaseDashboard";
import StoreManagement from "../pages/StoreDashboard";
import HumanResource from "../pages/HumanResourceDashboard";
import WarehouseManagement from "../pages/WarehouseDashboard";
import SalesDashboard from "../pages/SalesDashboard";
import Login from "../features/login";
import CompanyManagement from "../features/company";
import AssignPermissions from "../features/usermanagement/AssignPermissions";
import WarehouseNewManagement from "../pages/WarehouseNewDashboard";
import WarehouseDashboard from "../features/warehousenew/dashboard/WarehouseDashboard";

import Dashboard from "../features/dashboard/main/Dashboard";
import ProductionDashboard from "../features/dashboard/production/ProductionDashboard";
import Chat from "../features/chat/Chat";
import ProductionReports from "../features/production/mis/ProductionReport";



// General Routes
export const GeneralRoutes = (isLoggedIn, setIsLoggedIn) => [
  <Route key="home" path="/" element={isLoggedIn ? <Dashboard /> : <Navigate to="/signin" />} />,
  <Route key="signin" path="/signin" element={<Login onLogin={() => setIsLoggedIn(true)} />} />,
  <Route key="api-error" path="/api-error" element={<ApiErrorPage />} />
];

// Customer Routes
export const CustomerRoutes = [

 <Route  path="/ai" element={<Chat />}   />,
 
];

//Example Routes
export const ExampleRoutes = [
 
];

// Order Routes
export const OrderRoutes = [
  // <Route path="/order" element={<AddOrders />} />,
  // <Route key="order-management" path="/OrderManagement" element={<OrderManagement />} />
];

//Master  Routes
export const MasterRoutes = [
  <Route path="/master-menu" element={<Masters />} />,
  <Route path="/addWinder" element={<WinderMachine />} />,
  <Route path="/PartyMaster" element={<Party />} />,
  <Route path="/ProductMaster" element={<Product />} />,
  <Route path="/quality" element={<ProductIndex />} />
];

// Transaction Routes
export const TransactionRoutes = [
  <Route path="/transaction-menu" element={<TransactionIndex />} />,
];


// Sales Routes
export const SalesRoutes = [
  <Route path="/order-management" element={<SalesIndex />} />,
  <Route path="/sales-management" element={<SalesDashboard />} />,  
  <Route path="/sales-reports" element={<Reports />} />,
];

// Production and Purchase Routes
export const PurchaseAndProductionRoutes = [
  <Route path="/purchase-management" element={<PurchaseManagement />} />,
  <Route path="/production-management" element={<ProductionManagement />} />,  
  <Route path="/master-admin" element={<ViewMasterAdmin />} />,
  <Route path="/store-management" element={<StoreManagement />} />,
  <Route path="/production-management-report" element={<ProductionReports />} />,
  
];

// Dashboards
export const DashBoardRoutes = [
  <Route path="/organization-overview" element={<OrgOverview />} />,
  <Route path="/warehouse-overview" element={<WarehouseDashboard />} />,
  <Route path="/production-overview" element={<ProductionDashboard />} />,
];

// Warehouse Routes
export const WarehouseRoutes = [
  <Route key="warehouse" path="/warehouse-management" element={<WarehouseManagement />} />,
  <Route key="warehousenew" path="/warehouse-new-management" element={<WarehouseNewManagement />} />,
];

// User Management Routes
export const UserRoutes = [
  <Route path="/UserList/:CompanyId" element={<UserList />} />,
  <Route path="/RoleManagement/:CompanyId" element={<RoleManagement />} />,
  <Route path="/AssignPermissions/:CompanyId" element={<AssignPermissions />} />,
];

// Company Management Routes
export const CompanyManagementRoutes = [
  <Route path="/company-management" element={<CompanyManagement />} />,
];

// HR Management Routes
export const HRManagementRoutes = [
  <Route path="/human-resource" element={<HumanResource />} />,
  <Route path="/all-notifications" element={<ViewAllRequests />} />
];

// Costing Mangement Routes
export const CostingManagementRoutes = [
  <Route path="/costing-management" element={<CostingManagement />} />,
  <Route path="/bill-of-material" element={< BillOfMaterialIndex />} />,
];

// Misc Routes
export const MiscRoutes = [
  <Route key="reports" path="/reports" element={<Reports />} />
];
